var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.tag,{tag:"component"},[_vm._v(_vm._s(_vm._f("toUpperCase")(_vm.text)))])
}
var staticRenderFns = []

export { render, staticRenderFns }